import DeleteIcon from "@mui/icons-material/Delete"
import { Box, ImageList, ImageListItem, ImageListItemBar, Typography } from "@mui/material"
import { File } from "graphql/types"
import { getImageURL } from "utils/getFileURL"

type MiniGaleryProps = {
  images: File[]
  // eslint-disable-next-line no-unused-vars
  onDelete?: (arg: string) => void
  deleteButton?: boolean
}

export const MiniGalery = (props: MiniGaleryProps) => {
  const { images, onDelete = () => {}, deleteButton = true } = props
  return (
    <ImageList sx={{ width: "100%" }} cols={4}>
      {images.map((item) => (
        <Box key={item.id}>
          <ImageListItem key={item.id}>
            <img src={getImageURL(item.id)} alt={item.name} />
            <ImageListItemBar
              subtitle={item.name}
              position="below"
              actionIcon={
                <>
                  {deleteButton && (
                    <Typography>
                      <DeleteIcon onClick={() => onDelete(item.id)} />
                    </Typography>
                  )}
                </>
              }
              sx={{
                "& .MuiImageListItemBar-titleWrap": {
                  width: "100%",
                  whiteSpace: "normal",
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                },
                "& .MuiImageListItemBar-subtitle": {
                  display: "block",
                  whiteSpace: "normal",
                },
                "& .MuiImageListItemBar-actionIcon": {
                  display: "flex",
                  alignItems: "center",
                },
              }}
            />
          </ImageListItem>
        </Box>
      ))}
    </ImageList>
  )
}
